/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemTextInputFormat } from './formPagePropertyItemTextInputFormat';
import { FormPagePropertyItemReEnterSetting } from './formPagePropertyItemReEnterSetting';
import { FormPagePropertyItemTextAllOfCharacterTypeAllowed } from './formPagePropertyItemTextAllOfCharacterTypeAllowed';
import { FormPagePropertyItemTextErrorMessage } from './formPagePropertyItemTextErrorMessage';


export interface FormPagePropertyItemTextAllOf { 
    type: FormPagePropertyItemTextAllOf.TypeEnum;
    /**
     * 入力可能な最大文字数。超えた場合はバリデーションエラー 郵便番号形式の場合は含めない 
     */
    maxLength?: number;
    /**
     * 入力可能な最大文字数(管理画面で設定された文字数。入力可能文字数としてコンシューマ側で表示する用途) 
     */
    maxLengthOrigin?: number;
    /**
     * 入力可能な最小文字数。超えた場合はバリデーションエラー 郵便番号形式の場合は含めない 
     */
    minLength?: number;
    /**
     * 入力可能な最小文字数(管理画面で設定された文字数。入力可能文字数としてコンシューマ側で表示する用途) 
     */
    minLengthOrigin?: number;
    /**
     * 入力可能な文字種を正規表現として表現。後続の使用できる文字種、スペース入力を許可するかどうかで決まる。 なお、「スペースを許可しない」制限は、その他の任意の文字種制限を設定しないと無視される。 また、入力形式によっても変える想定。姓名型だと間に全角スペース、電話番号、郵便番号だと間にハイフンが入る 
     */
    pattern?: string;
    reEnter?: FormPagePropertyItemReEnterSetting;
    /**
     * 伏字にするか
     */
    password?: boolean;
    characterTypeAllowed?: FormPagePropertyItemTextAllOfCharacterTypeAllowed;
    inputFormat: FormPagePropertyItemTextInputFormat;
    errorMessage?: FormPagePropertyItemTextErrorMessage;
}
export namespace FormPagePropertyItemTextAllOf {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
}



